export const EnvCard2RealCard = {
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: 'T',
    11: 'J',
    12: 'Q',
    13: 'K',
    14: 'A',
    17: '2',
    20: 'X',
    30: 'D',
};

export const RealCard2EnvCard = {
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    T: 10,
    J: 11,
    Q: 12,
    K: 13,
    A: 14,
    2: 17,
    X: 20,
    D: 30,
};

export function parseDouzeroCardString(str) {
    if (!str) return [];
    return [...str].map((c) => RealCard2EnvCard[c]).filter((n) => n !== undefined);
}

export function envCardsToDouzeroString(cards) {
    return cards.map((c) => EnvCard2RealCard[c]).join('');
}

export const POSITION_MODELS = ['landlord', 'landlord_down', 'landlord_up'];
